import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../root-reducer';
import thunk from 'redux-thunk';


export const newStore = () => {
  const store = createStore(
    rootReducer,
    applyMiddleware(thunk));

  if (module.hot) {
    module.hot.accept('../root-reducer', () => {
      const nextRootReducer = require('../root-reducer');
      store.replaceReducer(nextRootReducer)
    })
  }
  
  return store;
};


// WEBPACK FOOTER //
// ./src/stores/store.js